import React from 'react';

const PITLTransferSuccess = ({ gearOrder, transferRequest, setTransferRequest }) => {
	const returnToOrder = () => {
		setTransferRequest({});
	};

	return (
		<>
			<h1>Success!</h1>
			<p>Your collection pack(s) have been transferred.</p>
			<p>We've emailed the new patient confirmation along with instructions to log in and view their order.</p>
			<p>
				They can also visit{' '}
				<a href={`/connect/${transferRequest.transferredOrderId}`}>
					www.gdx.net/connect/{transferRequest.transferredOrderId}
				</a>{' '}
				to access their order at any time.
			</p>
			{(transferRequest.partialTransfer) && (
				<button className="btn btn-white rounded-pill btn-sm margin-clear" onClick={returnToOrder}>
					<i className="ps-2 pe-2 fa fa-arrow-circle-left"></i>
					Return to my order
				</button>
			)}
		</>
	);
};

export default PITLTransferSuccess;
